/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to get market statistics with pagination and sorting
 * @export
 * @interface GetMarketStatisticsCommand
 */
export interface GetMarketStatisticsCommand {
    /**
     * Fenêtre temporelle en mois (années converties côté front)
     * @type {number}
     * @memberof GetMarketStatisticsCommand
     */
    months?: number;
    /**
     * Page number (1-indexed)
     * @type {number}
     * @memberof GetMarketStatisticsCommand
     */
    page?: number;
    /**
     * Items per page
     * @type {number}
     * @memberof GetMarketStatisticsCommand
     */
    pageSize?: number;
    /**
     * Field to sort by (clés canoniques back)
     * @type {string}
     * @memberof GetMarketStatisticsCommand
     */
    sortBy?: GetMarketStatisticsCommandSortByEnum;
    /**
     * Sort direction
     * @type {string}
     * @memberof GetMarketStatisticsCommand
     */
    sortDirection?: GetMarketStatisticsCommandSortDirectionEnum;
}


/**
 * @export
 */
export const GetMarketStatisticsCommandSortByEnum = {
    SubscriberName: 'subscriberName',
    CustomerSince: 'customerSince',
    ContractCount: 'contractCount',
    SimulationCount: 'simulationCount',
    TotalPremiumHt: 'totalPremiumHT'
} as const;
export type GetMarketStatisticsCommandSortByEnum = typeof GetMarketStatisticsCommandSortByEnum[keyof typeof GetMarketStatisticsCommandSortByEnum];

/**
 * @export
 */
export const GetMarketStatisticsCommandSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetMarketStatisticsCommandSortDirectionEnum = typeof GetMarketStatisticsCommandSortDirectionEnum[keyof typeof GetMarketStatisticsCommandSortDirectionEnum];


/**
 * Check if a given object implements the GetMarketStatisticsCommand interface.
 */
export function instanceOfGetMarketStatisticsCommand(value: object): value is GetMarketStatisticsCommand {
    return true;
}

export function GetMarketStatisticsCommandFromJSON(json: any): GetMarketStatisticsCommand {
    return GetMarketStatisticsCommandFromJSONTyped(json, false);
}

export function GetMarketStatisticsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketStatisticsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'months': json['months'] == null ? undefined : json['months'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
    };
}

export function GetMarketStatisticsCommandToJSON(json: any): GetMarketStatisticsCommand {
    return GetMarketStatisticsCommandToJSONTyped(json, false);
}

export function GetMarketStatisticsCommandToJSONTyped(value?: GetMarketStatisticsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'months': value['months'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'sortBy': value['sortBy'],
        'sortDirection': value['sortDirection'],
    };
}

